var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 41,
    viewBox: "0 0 97 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3998 2.6972C7.15981 2.6972 0.799805 8.9372 0.799805 17.1772C0.799805 25.4572 7.15981 31.6972 15.3998 31.6972C23.6398 31.6972 29.9598 25.4572 29.9598 17.1772C29.9598 8.9372 23.6398 2.6972 15.3998 2.6972ZM15.3998 8.1372C20.3998 8.1372 24.1598 11.9772 24.1598 17.1772C24.1598 22.4172 20.3998 26.2572 15.3998 26.2572C10.3598 26.2572 6.5998 22.4172 6.5998 17.1772C6.5998 11.9772 10.3598 8.1372 15.3998 8.1372Z",
    fill: "#182C43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3323 13.7772V9.1772H34.4123V22.3772H45.6123V26.6172H34.4123V31.1772H51.3323V17.4972H40.1323V13.7772H51.3323Z",
    fill: "#182C43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6007 31.1772H64.3207V17.4172H71.6407V12.0172H64.3207V5.7772H71.6407V0.377197H58.6007V12.0172H54.8007V17.4172H58.6007V31.1772Z",
    fill: "#182C43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5945 40.3772L96.5145 9.1772H90.4345L84.9545 21.8972L79.5145 9.1772H73.3945L81.9145 28.2572L76.5145 40.3772H82.5945Z",
    fill: "#182C43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f4077e6ccd08e0afab37c9286dea0faf.svg";
export { ForwardRef as ReactComponent };